import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Hook that scrolls to the top of the page when the route pathname changes,
 * but preserves hash-based scrolling.
 */
export default function useScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, let the page handle scrolling to that hash
    // (e.g., LandingPage has logic for hash scrolling)
    if (hash) {
      return;
    }

    // Scroll to top when pathname changes
    window.scrollTo(0, 0);
  }, [pathname, hash]);
}

